module.exports = __webpack_public_path__ + "static/staffing-2b8592845c38540cd6089fe8ab24b6e0.jpg";